module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-portal-5.eee724f7.svg";